import { render, staticRenderFns } from "./ResetSeparateAccountPasswordModal.vue?vue&type=template&id=180434b2&"
import script from "./ResetSeparateAccountPasswordModal.vue?vue&type=script&lang=js&"
export * from "./ResetSeparateAccountPasswordModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports